import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { COPY } from '../presentationCopy';
import { PRES, TYPE } from '../chrome';

interface BoundFieldEditDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const BoundFieldEditDialog: React.FC<BoundFieldEditDialogProps> = ({
  open,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
    <DialogTitle>{COPY.boundFieldPromptTitle}</DialogTitle>
    <DialogContent>
      <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textSecondary, whiteSpace: 'pre-line' }}>
        {COPY.boundFieldPromptBody}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} sx={{ textTransform: 'none' }}>{COPY.cancel}</Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        sx={{ bgcolor: PRES.interactive, textTransform: 'none', boxShadow: 'none' }}
      >
        {COPY.boundFieldPromptConfirm}
      </Button>
    </DialogActions>
  </Dialog>
);

export default BoundFieldEditDialog;
